export var ListNode;
(function (ListNode) {
    ListNode["ListItem"] = "list_item";
    ListNode["BulletList"] = "bullet_list";
    ListNode["OrderedList"] = "ordered_list";
})(ListNode || (ListNode = {}));
